import React, { useEffect, useState } from "react";
import { Container, Card, CardBody } from "reactstrap";
import ErrorBoundary from "components/ErrorBoundary";
import QueryToolTable from "./QueryToolTable";
import SearchContainer from "./SearchContainer";
import useAxios from 'hooks/useAxios';
import Drawer from "components/Drawer";
import QueryToolDraw from "components/QueryToolDraw";
import { toast } from 'react-toastify';
import { onExport } from "utils/helper";

const QueryTool = (props) => {

    const API = useAxios();
    const [loading, setLoading] = useState(false);
    const [queryRepoabledata, setQueryRepoTabledata] = useState([]);
    const [commentDrawer, setCommentDrawer] = useState(false);

    const toggCommentDrawerqt = () => {
        setCommentDrawer(!commentDrawer);
    };

    useEffect(() => {
        fetchQueryReportList()
    }, []);
    const { profile } =
        JSON.parse(sessionStorage.getItem('pharmaforce')) || {};

    const { sub } = profile || {};

    const download = async (rowdata) => {

        try {
            const { access_token } = JSON.parse(sessionStorage.getItem('pharmaforce')) || {};

            var url = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/queryTool/download/${rowdata?.encryptedQueryReportID}?access_token=${access_token}`;
            // alert(url);
            window.open(url, "_blank");

        } catch (error) {

            console.log(error);
        }
    };

    const Retry = async (e) => {
        var queryReportID = e.queryReportID
        const { id_token } = JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/queryTool/retry/${queryReportID}?access_token=${id_token}`;
        onExport(action);
    };
    const RefreshButton = async () => {
        fetchQueryReportList();
    };

    const fetchQueryReportList = async () => {

        setLoading(true);
        try {
            const { data } = await API.post(
                `/queryTool/getqueryreportlist`,
            );
            if (data) {
                setQueryRepoTabledata(data);
            } else {
                setData([]);
            };

            setLoading(false);
        } catch (error) {
            setLoading(false);
            setQueryRepoTabledata([]);
        };
    };
    const saveQueryReport = async (row) => {
        const payload = {}
        payload.QueryID = row.queryid;
        payload.ConnectionID = row.connectionId;
        payload.ReportName = row.reportnameval;
        payload.RequestedBy = row.requestedbyval;
        payload.ParametersJson = row.parameterName;
        payload.LoginID = sub;
        debugger;
        const result = await API.post(`/queryTool/savequeryreport`, payload, {
            hasDefaultURL: false,
            hideLoader: true,
        });
        if (result) {
            toast.success("Item Save successfully");
            setCommentDrawer(!commentDrawer);
            fetchQueryReportList();
        };
    };
       const handleExport = async () => {
    const { access_token } =
      JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    // const action = `${process.env.REACT_APP_ENDPOINT}/GWConfig/Contracts/ExportAll/${searchTerms.thirdPartyAdminID|| 0 }?access_token=${access_token}`;
    onExport(action, search);
  };
    return (
        <div>
            <Container fluid className='width_info'>
                <Card className='border-0 shadow-top'>
                    <CardBody className='section-devider-border'>
                        <ErrorBoundary>
                            <SearchContainer
                                toggCommentDrawer={toggCommentDrawerqt}
                                RefreshButton={RefreshButton}
                            />
                        </ErrorBoundary>
                    </CardBody>
                    <CardBody className='pt-2'>
                        <ErrorBoundary>
                            <QueryToolTable
                                toggCommentDrawer={toggCommentDrawerqt}
                                loading={loading}
                                tabledata={queryRepoabledata}
                                download={download}
                                Retry={Retry}
                                onExport={handleExport}
                            />
                        </ErrorBoundary>
                    </CardBody>
                </Card>
            </Container>
            <Drawer
                isOpen={commentDrawer}
                direction='end'
                title='Create New Report'
                size="md"
                toggle={toggCommentDrawerqt}
            >
                <QueryToolDraw
                
                    saveQueryReport={saveQueryReport}
                />
            </Drawer>
        </div>
    );
};

export default QueryTool;